import { createRouter, createWebHistory } from 'vue-router';
import { examReq } from '@/Mixins/Class/Request.js';
import HomeView from '../views/Welcome.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/pre-exam',
      name: 'login',
      component: () => import('@/views/Auth/CameraLogin.vue'),
    },
    {
      path: '/exam',
      name: 'ujian',
      component: () => import('@/views/Exam/ExamRoomContainer.vue'),
    },
    {
      path: '/post-exam/:sid/:pid',
      name: 'eval',
      props: true,
      component: () => import('@/views/PostExam.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!['/', '/pre-exam'].includes(to.path) && !to.path.startsWith('/post-exam') && !examReq.getRefreshTk()) {
    next('/pre-exam');
  } else {
    next();
  }
});

export default router;
